module.exports = __webpack_public_path__ + "img/kissmetrics.73fd1650.jpg";